import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { createFetcher } from '../libs/next/api/jsonApiHandler'
import type { API } from '../pages/api/filter/[handler]'
import { useDebounce } from './useDebouncedValue'

const api = createFetcher<API>('/api/filter/[handler]')

export function useQuickSearch(query: string | null) {
	const lowercased = query?.toLowerCase()

	const q = useDebounce(lowercased, 300)
	return useQuery({
		queryKey: ['search', q] as const,
		queryFn: async (context) => {
			return api('quickSearch', { _req: { query: { q: context.queryKey[1] as string } } })
		},
		enabled: Boolean(query),
		placeholderData: keepPreviousData,
	})
}
